import cartMixin from '@/mixins/cartMixin'

export default {
  mixins: [cartMixin],

  methods: {
    async logout() {
      await this.$auth.logout()
      this.$store.commit('SET_CART', null)
      this.$store.commit('SET_FAVORITES', [])
      setTimeout(() => {
        this.loadCart()
        this.$store.dispatch('setFavorites')
      }, 500)
    },
  },
}
